// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn---wTRL";
export var btnBlock = "banner-module--btnBlock--9xRVY";
export var container = "banner-module--container--KR0eA";
export var hideMobBlock = "banner-module--hideMobBlock--VfmD9";
export var img = "banner-module--img--0KHT8";
export var mobBtn = "banner-module--mobBtn--7jTKE";
export var secondContainer = "banner-module--secondContainer--3LmFY";
export var section = "banner-module--section--1EVJN";
export var text = "banner-module--text--nQqPK";